module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-empty.d81667f7.svg";